export default {
    chat: 'Czat',
    errors: {
        'load-previous': 'Wystąpił błąd podczas ładowania. Spróbuj ponownie później.',
        'send-message': 'Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie później.',
        'throttle': 'Wysyłasz za dużo wiadomości! Oj niegrzeczny...',
        'vulgar-nick': 'Zachowuj się! Tak nie wypada :('
    },
    gdpr: 'Nie możesz skorzystać z czatu, ponieważ nie zaakceptowałeś naszej polityki prywatności. Znajdziesz ją pod tym linkiem:',
    message: 'Wiadomość',
    nick: 'Nick',
    retry: 'Spróbuj ponownie',
    status: {
        'loading': 'Ładowanie wiadomości. Poczekaj chwilę ;-)',
        'no-messages': 'Brak wiadomości :(',
        'offline': 'Czat jest aktualnie niedostępny. Spróbuj ponownie później'
    }
}
